import React from 'react'
import Container from '@material-ui/core/Container';
import plano1 from '../../assets/planols.png';
import pdf from '../../assets/planoslasoñada.pdf';


const Section4 = () => {
  return (
    <div id='planos' className='section noPadBot planoszen'>
        <Container className='relative flex flexCol'>
          
            <div className="flex flexCol flexCenter planos">
                  <img src={plano1} alt="Plano 1" />
                  <h5>Planta Baja</h5>
              <div className="floatTitle shadow">
                <h2>Descripción</h2>
                <p>Palier de acceso, recibidor, 3 dormitorios, baño completo, cocina comedor, living, terraza con amenities.</p>
                <a href={pdf} className='btnBox flex flexRow horiCenter' target="_blank" rel="noopener noreferrer">Descargar planos
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.43 18.82C14.24 18.82 14.05 18.75 13.9 18.6C13.61 18.31 13.61 17.83 13.9 17.54L19.44 12L13.9 6.46C13.61 6.17 13.61 5.69 13.9 5.4C14.19 5.11 14.67 5.11 14.96 5.4L21.03 11.47C21.32 11.76 21.32 12.24 21.03 12.53L14.96 18.6C14.81 18.75 14.62 18.82 14.43 18.82Z" fill="#fff"/>
              <path d="M20.33 12.75H3.5C3.09 12.75 2.75 12.41 2.75 12C2.75 11.59 3.09 11.25 3.5 11.25H20.33C20.74 11.25 21.08 11.59 21.08 12C21.08 12.41 20.74 12.75 20.33 12.75Z" fill="#fff"/>
              </svg></a>
              </div>

            </div>
        </Container>
    </div>
  )
}

export default Section4